import { InstitucionSnp } from '@conacyt/persona-moral-reniecyt-client';

export const enum PERSONAS {
  MORAL = 'MORAL',
  FISICA = 'FISICA',
}

export const enum SECTORES {
  PRIVADO = 'PRIVADO',
  PUBLICO = 'PUBLICO',
  SOCIAL = 'SOCIAL',
}

export const PERSONAS_MAP: Record<PERSONAS, string> = {
  [PERSONAS.FISICA]: '2',
  [PERSONAS.MORAL]: '1',
};
export const SECTORES_MAP: Record<SECTORES, string> = {
  [SECTORES.PRIVADO]: '1',
  [SECTORES.PUBLICO]: '2',
  [SECTORES.SOCIAL]: '3',
};

export interface IPersonaMoral {
  nombreSede?: string;
  rfc?: string;
  noDeRegistro?: string;
  claveEntidadFederativa?: string;
  entidadFederativa?: string;
  claveMunicipio?: string;
  municipio?: string;
  sector?: string;
  subsdes?: Array<SubsedeMoral>;
}

export class PersonaMoral implements IPersonaMoral {
  constructor(
    public nombreSede?: string,
    public rfc?: string,
    public noDeRegistro?: string,
    public claveEntidadFederativa?: string,
    public entidadFederativa?: string,
    public claveMunicipio?: string,
    public municipio?: string,
    public sector?: string,
    public subsdes?: Array<SubsedeMoral>
  ) {
    if (!subsdes) {
      this.subsdes = [];
    }
  }

  static fromObject(data: InstitucionSnp): PersonaMoral {
    const cupo = new PersonaMoral();
    for (const [key, value] of Object.entries(data)) {
      cupo[key] = value;
    }
    return cupo;
  }
}

export interface ISubsedeMoral {
  nombreSede?: string;
  noDeRegistro?: string;
  claveEntidadFederativa?: string;
  entidadFederativa?: string;
  claveMunicipio?: string;
  municipio?: string;
  esLaSede?: boolean;
}

export class SubsedeMoral implements ISubsedeMoral {
  constructor(
    public nombreSede?: string,
    public noDeRegistro?: string,
    public claveEntidadFederativa?: string,
    public entidadFederativa?: string,
    public claveMunicipio?: string,
    public municipio?: string,
    public esLaSede?: boolean
  ) {}
}

/**
 * Filtro para buscar personas morales
 */
export interface IFiltroPersonaMoral {
  noDeRegistro?: string;
  rfc?: string;
  tipoSolicitud?: string;
  sector?: string;
}

export class FiltroPersonaMoral implements IFiltroPersonaMoral {
  constructor(public noDeRegistro?: string, public rfc?: string, public tipoSolicitud?: string, public sector?: string) {}
}
